import { render, staticRenderFns } from "./authModal.vue?vue&type=template&id=2d161203&scoped=true&"
import script from "./authModal.vue?vue&type=script&lang=ts&"
export * from "./authModal.vue?vue&type=script&lang=ts&"
import style0 from "./authModal.vue?vue&type=style&index=0&id=2d161203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d161203",
  null
  
)

export default component.exports